module.exports = __webpack_public_path__ + "static/media/kioskSlant.33bdf581.png";